if(!customElements.get('rocket-seo-section')) {
    customElements.define('rocket-seo-section',
     class rocketSeoSection extends HTMLElement {
        constructor() {
            super();
            this.sectionActive = this.querySelectorAll('.seo-collection-item.active');
            this.collectionTile = this.querySelectorAll('.seo-collection-title');

            this.removeSectionActive();
            this.initEventOpenClose();
        }

        initEventOpenClose() {
            this.collectionTile.forEach(item => {
                item.addEventListener('click', function () {
                    const el = this.parentElement;
                    el.classList.toggle('active');
                });
            })
        }

        removeSectionActive() {
            this.sectionActive.forEach(item => {
                item.classList.remove('active')
            })
        }
     }
    )
}